import { statusTexts } from 'feature/user/helpers/statusText'
import { User } from 'feature/user/types'
import { Button } from 'ui'
import { LoaderInCentalPosition } from 'widget'
import { EmailStatus } from 'widget/EmailStatus'

import style from './SendEmailConfirmBlock.module.scss'

type TSendEmailConfirmBlock = {
  data: User | undefined
  sendConfirm: () => void
  resendEditEmailLoading: boolean
  isEmailValid: boolean
}

type TEmailStatus = 'done' | 'progress'

// блок с кнопкой подтвержения email
export const SendEmailConfirmBlock = ({
  data,
  sendConfirm,
  isEmailValid,
  resendEditEmailLoading,
}: TSendEmailConfirmBlock) => {
  const emailStatus: TEmailStatus = data?.newEmail ? 'progress' : 'done'

  return (
    <div className={style.emailStatus}>
      <EmailStatus statusText={statusTexts[emailStatus]} status={emailStatus} />
      {data?.newEmail && (
        <Button
          variant='text'
          color='primary'
          onClick={sendConfirm}
          className={style.sendConfirm}
          disabled={!isEmailValid || resendEditEmailLoading}
          data-testid='email-send-confirm-btn'
        >
          {resendEditEmailLoading && <LoaderInCentalPosition />}
          Отправить подтверждение
        </Button>
      )}
    </div>
  )
}
